var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 17.9998C15.3089 17.9998 17.9999 15.3089 17.9999 11.9999C17.9999 8.69092 15.3089 5.99995 12 5.99995C8.69101 5.99995 6.00004 8.69092 6.00004 11.9999C6.00004 15.3089 8.69101 17.9998 12 17.9998ZM12 8.99992C13.6545 8.99992 14.9999 10.3454 14.9999 11.9999C14.9999 13.6544 13.6545 14.9999 12 14.9999C10.3455 14.9999 9.00001 13.6544 9.00001 11.9999C9.00001 10.3454 10.3455 8.99992 12 8.99992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.13 29.7207C11.3839 29.902 11.688 29.9994 12 29.9994C12.312 29.9994 12.6161 29.902 12.87 29.7207C13.326 29.3982 24.0434 21.6598 23.9999 11.9999C23.9999 5.38344 18.6164 0 12 0C5.38357 0 0.000132055 5.38344 0.000132055 11.9924C-0.0433675 21.6598 10.674 29.3982 11.13 29.7207ZM12 2.99997C16.9634 2.99997 20.9999 7.03642 20.9999 12.0074C21.0314 18.6643 14.418 24.6417 12 26.6022C9.58353 24.6402 2.9686 18.6613 3.0001 11.9999C3.0001 7.03642 7.03655 2.99997 12 2.99997Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_822"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 29.9997,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.4df73570e423e490d3364d9659319845.svg";
export { ForwardRef as ReactComponent };